import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../../Actions/AxiosInstance";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import { ReducersTypes } from "../../../../../../../Constants";
import LeavePlan from "..";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  isclubbingallowed: false,
  clubbingleave: [],
  // clubbingleave: {
  //   displayname: "All",
  //   displayvalue: null
  // },
  clubbingleaveid: null,
};
class ClubLeave extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
      clubbing: {
        displayname: "All",
        displayvalue: 0,
      },
      clubbingleave: [
        {
          displayname: "All",
          displayvalue: 0,
        },
      ],
      all: [
        {
          displayname: "All",
          displayvalue: 0,
        },
      ],
    };
  }

  componentWillMount() {
    this.SetValues(this.props);
    this.getLeaveList();
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () => {
        this.SetValues(props);
      });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      const { InitLeavesPolicy } = props;
      this.setState({
        ParentIndex,
        leavetypeid: props.leavetypeid,
        isclubbingallowed: InitLeavesPolicy.policy[ParentIndex]
          ? InitLeavesPolicy.policy[ParentIndex].isclubbingallowed
          : null,
      });
    } else {
      //   this.setState({ ...ParentState }, () => this.getLeaveList());
    }
  }

  handleChange(name, ...arg) {
    switch (name) {
      case "isclubbingallowed": {
        this.setState({ [name]: arg[0], clubbingleave: [] }, () => {
          this.UpdateReducer();
        });
        break;
      }
      case "clubbingleave": {
        this.multiOptions(name, arg);
        break;
      }
      default:
        break;
    }
  }

  multiOptions(name, arg) {
    if (this.state.LeaveList && this.state.LeaveList.length > 0) {
      let obj = [];
      let clubbingleave = {};
      const filterObj = arg[0] && arg[0].find((x) => x.displayvalue == 0);
      if (filterObj) {
        obj = [0];
        clubbingleave = filterObj;
      } else {
        arg[0] = arg[0] && arg[0].length > 0 ? arg[0] : [];
        for (const val of arg[0]) {
          obj.push(val.displayvalue);
        }
        clubbingleave = arg[0];
      }
      // if (filterObj) {
      //   obj = [0];
      //   clubbingleave = filterObj;
      // } else {
      //
      // }
      obj = obj.length > 0 ? obj : 0;
      this.setState({ clubbingleaveid: obj, clubbingleave }, () => {
        this.UpdateReducer();
      });
    } else if (arg[0] && arg[0].length == 0) {
      this.setState({ clubbingleaveid: 0, clubbingleave: 0 }, () => {
        this.UpdateReducer();
      });
    } else {
      this.setState(
        { clubbingleaveid: 0, clubbingleave: this.state.all[0] },
        () => this.UpdateReducer(),
      );
    }
  }

  getLeaveList() {
    const { details, leaveid } = this.props.InitLeavesPolicy;
    const leavepolicyid = this.props.InitLeavesPolicy.leavepolicyid
      ? this.props.InitLeavesPolicy.leavepolicyid
      : null;
    let leavetypeids = [];

    // if (details.length > 0) {
    //   // for (const detail of details) {
    //   //   leavetypeids.push(detail.leavetypeid);
    //   // }
    //   leavetypeids = [4, 3];
    // } else {
    //   leavetypeids = [4, 3];
    // }

    leavetypeids = [4, 3];

    if (leavepolicyid) {
      instance
        .post(`/leaves/leavelistbypolicyid`, {
          leavepolicyid,
          leavetypeids,
        })
        .then(
          (result) => {
            if (result.data.result.length >= 0) {
              result.data.result.unshift({
                displayname: "All",
                displayvalue: 0,
              });
            }
            const { InitLeavesPolicy } = this.props;
            let ids = null;
            if (
              InitLeavesPolicy.policy[this.state.ParentIndex] &&
              InitLeavesPolicy.policy[this.state.ParentIndex].clubbingleaveid
            ) {
              ids =
                InitLeavesPolicy.policy[this.state.ParentIndex].clubbingleaveid;
              ids = ids && ids.split(",");
            }
            this.setState(
              {
                LeaveList: leaveid
                  ? result.data.result.filter(
                      (leave) => leave.displayvalue != leaveid,
                    )
                  : result.data.result,
                clubbingleaveid: ids,
              },
              () => {
                const idstemp = this.state.clubbingleaveid;
                // here
                let clubbingleave = [];
                if (idstemp) {
                  for (const id of idstemp) {
                    const filter = this.state.LeaveList.find(
                      (x) => x.displayvalue == id,
                    );
                    clubbingleave.push(filter);
                  }
                } else {
                  clubbingleave = [{ displayname: "All", displayvalue: 0 }];
                }
                this.setState({ clubbingleave });
              },
            );
          },
          (error) => {
            const CommonError = error.response
              ? error.response.data.error.message
              : error.message;
            this.props.enqueueSnackbar(CommonError, { variant: "error" });
          },
        );
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      isclubbingallowed: this.state.isclubbingallowed,
      // clubbingleaveid: this.state.clubbingleaveid
      clubbingleaveid: this.state.clubbingleaveid
        ? this.state.clubbingleaveid.join()
        : this.state.clubbingleaveid,
    };
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  render() {
    const language = this.props.Language.clubleave;
    return (
      <IntlProvider locale="en" messages={language}>
        <div>
          <div className="inner-wrapper margin-top-20 opaque">
            <div className="margin-bottom-20">
              <p className="form-main-header margin-top-20">
                <FormattedMessage
                  id="__LbLeaveClubbing"
                  defaultMessage="Leave Clubbing"
                />
              </p>
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="__LbAllowClubbingLeaves"
                  defaultMessage="Allow employees to apply for different types of leaves, adjacent to each other (clubbing different leaves for dates falling before/after each other)"
                />
              </p>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isclubbingallowed", true)}
                aria-expanded={this.state.isclubbingallowed == true}
              >
                <span>
                  <FormattedMessage id="LbYes" defaultMessage="Yes" />
                </span>
                {this.state.isclubbingallowed == true ? (
                  <span className="floatright ">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected " />
                )}
              </div>
              <div className="et-level2">
                <div className="">
                  <Collapse
                    in={this.state.isclubbingallowed}
                    timeout="auto"
                    unmountOnExit
                    className="padding30 overflow-initial"
                  >
                    <FormattedMessage
                      id="LbFollowingLeaveTypes"
                      defaultMessage="For the following type(s) of leaves"
                    />
                    <Select
                      class="form-control"
                      autofocus
                      placeholder="Select Leave Type"
                      isMulti
                      options={
                        this.state.LeaveList && this.state.LeaveList.length > 0
                          ? this.state.LeaveList
                          : this.state.all
                      }
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayvalue}
                      onChange={this.handleChange.bind(this, "clubbingleave")}
                      value={this.state.clubbingleave}
                      className="margin-top-8 width58"
                    />
                  </Collapse>
                </div>
              </div>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isclubbingallowed", false)}
                aria-expanded={this.state.isclubbingallowed == false}
              >
                <span>
                  <FormattedMessage id="LbNo" defaultMessage="No" />
                </span>
                {this.state.isclubbingallowed == false ? (
                  <span className="floatright ">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected " />
                )}
              </div>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}
ClubLeave.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(ClubLeave)));
